'use strict';

var React = require('react');

var SvgPriceListFilledIcon = function SvgPriceListFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 3.5h8.5a1 1 0 0 1 1 1v3.765a2 2 0 0 0-2.076 1.167 3.251 3.251 0 0 0-1.366 5.212 1.997 1.997 0 0 0-.793 1.856h-5.265a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1Zm1.125 3.25c0-.345.28-.625.625-.625h5a.625.625 0 1 1 0 1.25h-5a.625.625 0 0 1-.625-.625Zm0 3c0-.345.28-.625.625-.625h2.75a.625.625 0 1 1 0 1.25h-2.75a.625.625 0 0 1-.625-.625Zm0 3c0-.345.28-.625.625-.625h2.25a.625.625 0 1 1 0 1.25h-2.25a.625.625 0 0 1-.625-.625Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.25 9.5a.749.749 0 0 1 .75.75v.25h.75a.75.75 0 0 1 0 1.5h-2.25a.5.5 0 0 0 0 1h1a2 2 0 1 1 0 4 .75.75 0 0 1-1.5 0h-.75a.75.75 0 0 1-.002-1.5h2.252a.5.5 0 0 0 0-1h-1a2 2 0 1 1 0-4v-.25a.75.75 0 0 1 .75-.75Z"
  }));
};
SvgPriceListFilledIcon.displayName = "PriceListFilledIcon";

exports.SvgPriceListFilledIcon = SvgPriceListFilledIcon;
